import React, { useEffect, useState, Fragment, useRef } from "react";
import { Listbox, Transition } from "@headlessui/react";
import ConfettiExplosion from "react-confetti-explosion";

import "./index.css";
import InputDown from "./InputDown";

function getClskValue() {
  var name = "_clck" + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");

  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i];
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) == 0) {
      let cookieString = cookie.substring(name.length, cookie.length);
      // split by | and get the first value if it exists
      let cookieArray = cookieString.split("|");
      if (cookieArray.length > 0) {
        return `https://clarity.microsoft.com/projects/view/h95a2h68ck/dashboard?date=Last%2030%20days&UserId=is%3B${cookieArray[0]}`;
      }
      return cookieString;
    }
  }

  return null;
}

const gethHutk = () => {
  var hutk = document.cookie.replace(
    /(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
  return hutk || "";
};

function SubmitIcon(props) {
  return (
    <svg
      width={39}
      height={23}
      viewBox="0 0 39 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 11.5h34m0 0L27.5 3m8.5 8.5L27.5 20"
        stroke="#0C1414"
        strokeWidth={3}
        strokeLinecap="square"
      />
    </svg>
  );
}

const sources = [
  { id: ``, name: "" },
  { id: `linkedin`, name: "LinkedIn" },
  { id: `search`, name: "Search" },
  { id: `podcast`, name: "Podcast" },
  { id: `instagram`, name: "Instagram" },
  { id: `word-of-mouth`, name: "Word of Mouth" },
  { id: `other`, name: "Other" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const SourceBox = ({ selected, setSelected }) => {
  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => {
        return (
          <>
            <Listbox.Label className="sr-only">
              How did you hear about us?
            </Listbox.Label>
            <div className="relative flex-grow">
              <Listbox.Button className="listbox bg-white w-full flex items-center justify-center focus:outline-none">
                <span className="sr-only"> Select Source</span>
                {selected.name != "" && (
                  <span className="mr-3 block truncate">{selected.name}</span>
                )}

                <InputDown open={open} />
              </Listbox.Button>

              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto bg-white text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-sm">
                  {sources.map((person) => {
                    if (person.id == "") {
                      return null;
                    }

                    return (
                      <Listbox.Option
                        key={person.id}
                        className={({ active }) =>
                          classNames(
                            active ? "bg-green text-white" : "text-gray-900",
                            "relative cursor-default select-none py-2 pl-3 pr-9"
                          )
                        }
                        value={person}
                      >
                        {({ selected, active }) => (
                          <>
                            <div className="flex items-center">
                              <span
                                className={`${selected ? `font-semibold` : ``}`}
                              >
                                {person.name}
                              </span>
                            </div>

                            {selected ? (
                              <span
                                className={classNames(
                                  active ? "text-white" : "text-indigo-600",
                                  "absolute inset-y-0 right-0 flex items-center pr-4"
                                )}
                              ></span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    );
                  })}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        );
      }}
    </Listbox>
  );
};

const ContactForm = () => {
  const [selected, setSelected] = useState(sources[0]);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const formRef = useRef(null);

  const [firstVisitData, setFirstVisitData] = useState(null);
  const [lastVisitData, setLastVisitData] = useState(null);

  const [currentUrl, setCurrentUrl] = useState(null);
  const [currentTitle, setCurrentTitle] = useState(null);

  const [clsk, setClSk] = useState(null);

  const [hubspot, setHubspot] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    let myForm = formRef.current;
    let formData = new FormData(myForm);
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString()
    })
      .then(() => console.log("Form successfully submitted"))
      .catch((error) => alert(error));

    setFormSubmitted(true);
    setIsExploding(true);
    // reset form
    myForm.reset();
  };

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const clsk = getClskValue();
      setClSk(clsk);
      const firstVisit = localStorage.getItem("tracking_first_visit");
      const currentVisit = localStorage.getItem("tracking_current_visit");
      setFirstVisitData(JSON.parse(firstVisit));
      setLastVisitData(JSON.parse(currentVisit));
      setCurrentUrl(window.location.href);
      setCurrentTitle(window.document.title);
      // get hubspot cookie
      setHubspot(gethHutk());
    }
  }, []);

  return (
    <>
      <div className="flex items-center justify-center">
        <form
          className="lg:max-w-[62.5rem] mx-auto  border-t lg:border-t-0 border-black py-8 text-sm lg:text-2xl contact-form w-fit"
          onSubmit={handleSubmit}
          ref={formRef}
          data-netlify="true"
          method="POST"
          name="contact"
          netlify-honeypot="bot-field"
        >
          <h2 className="font-semibold text-lg lg:text-3xl">
            {`Enquire here. You’ll love this bit.`}
          </h2>
          <div className="pt-6 flex flex-col lg:flex-row">
            <div className="flex items-center flex-grow">
              <label htmlFor="name" className="sr-only">
                First and last name
              </label>{" "}
              <span>Tell us your</span>
              <input
                type="text"
                name="name"
                id="name"
                className="ml-2 flex-grow"
                placeholder="name"
                required
              />
            </div>
            <div className="flex items-center pt-3 lg:pt-0 flex-grow">
              <label htmlFor="business_name" className="sr-only">
                Business Name
              </label>
              <span className="ml-2 hidden lg:inline-block">,</span>
              <input
                type="text"
                name="business_name"
                id="business_name"
                className="lg:ml-4 flex-grow w-full lg:w-auto"
                placeholder="business name"
                required
              />
            </div>
          </div>
          <div className="pt-3 lg:pt-6 flex flex-row items-center">
            <span className="mr-2">&</span>
            <label htmlFor="email" className="sr-only">
              Your email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              className="lg:ml-4 flex-grow w-full lg:w-auto"
              placeholder="email"
              required
            />
          </div>
          <div className="pt-3 lg:pt-6 flex flex-row items-start">
            <label htmlFor="brief" className="sr-only">
              Your brief
            </label>
            <span className="mr-2 mt-[0.265rem] lg:mt-[0.6rem]">
              What is your
            </span>{" "}
            <textarea
              type="text"
              name="brief"
              id="brief"
              className="flex-grow !h-40 lg:!h-28"
              placeholder="brief?"
              rows={4}
            />
          </div>

          <div className="pt-3 lg:pt-6 flex flex-row items-center">
            <input
              className="hidden"
              type="text"
              defaultValue={selected?.id}
              name="source"
              id="source"
            />
            <span className="mr-2">How did you hear about us? </span>
            <SourceBox selected={selected} setSelected={setSelected} />
          </div>

          <div className="pt-3 lg:pt-6 flex flex-row items-center justify-between">
            <span className="mr-2">
              Click to opt out of valuable monthly email newsletters and make a
              baby seal cry.
            </span>
            <label className="hidden" htmlFor="email_opt_out">
              Email opt out
            </label>
            <input
              id="email_opt_out"
              name="email_opt_out"
              type="checkbox"
              className="h-12 w-12 aspect-square focus:ring-green checked:bg-green text-green"
            />
          </div>

          <div className="hidden">
            <input type="hidden" name="form-name" defaultValue="contact" />

            <input
              type="hidden"
              name="first_visit__referrer"
              defaultValue={firstVisitData?.referrer || ""}
            />
            <input
              type="hidden"
              name="first_visit__utm_source"
              defaultValue={firstVisitData?.utm_source || ""}
            />
            <input
              type="hidden"
              name="first_visit__utm_medium"
              defaultValue={firstVisitData?.utm_medium || ""}
            />
            <input
              type="hidden"
              name="first_visit__utm_campaign"
              defaultValue={firstVisitData?.utm_campaign || ""}
            />
            <input
              type="hidden"
              name="first_visit__utm_term"
              defaultValue={firstVisitData?.utm_term || ""}
            />
            <input
              type="hidden"
              name="first_visit__utm_content"
              defaultValue={firstVisitData?.utm_content || ""}
            />
            <input
              type="hidden"
              name="first_visit__date"
              defaultValue={firstVisitData?.date || ""}
            />
            <input
              type="hidden"
              name="first_visit__landing_page"
              defaultValue={firstVisitData?.landingPage || ""}
            />

            <input
              type="hidden"
              name="last_visit__referrer"
              defaultValue={lastVisitData?.referrer || ""}
            />
            <input
              type="hidden"
              name="last_visit__utm_source"
              defaultValue={lastVisitData?.utm_source || ""}
            />
            <input
              type="hidden"
              name="last_visit__utm_medium"
              defaultValue={lastVisitData?.utm_medium || ""}
            />
            <input
              type="hidden"
              name="last_visit__utm_campaign"
              defaultValue={lastVisitData?.utm_campaign || ""}
            />
            <input
              type="hidden"
              name="last_visit__utm_term"
              defaultValue={lastVisitData?.utm_term || ""}
            />
            <input
              type="hidden"
              name="last_visit__utm_content"
              defaultValue={lastVisitData?.utm_content || ""}
            />
            <input
              type="hidden"
              name="last_visit__date"
              defaultValue={lastVisitData?.date || ""}
            />
            <input
              type="hidden"
              name="last_visit__landing_page"
              defaultValue={lastVisitData?.landingPage || ""}
            />

            <input type="hidden" name="clsk" defaultValue={clsk || ""} />
            <input type="hidden" name="hutk" defaultValue={hubspot || ""} />

            <input
              type="hidden"
              name="current_url"
              defaultValue={currentUrl || ""}
            />
            <input
              type="hidden"
              name="current_title"
              defaultValue={currentTitle || ""}
            />
          </div>

          <p className="hidden">
            <label>
              Don’t fill this out if you’re human: <input name="honey-field" />
            </label>
          </p>

          <div className="flex lg:justify-end pt-6 items-center relative">
            {formSubmitted ? (
              <p className="text-black text-right pt-2 underline font-semibold">
                Thank you for your enquiry. We will be in touch soon.
              </p>
            ) : (
              <button
                className="text-lg ml-auto flex space-x-4 items-center"
                type="submit"
              >
                <SubmitIcon /> <span>Submit</span>
              </button>
            )}
          </div>
        </form>
      </div>
      {/* Desktop Form */}
      {/*
            <form className="lg:max-w-[62.5rem] mx-auto lg:ml-44 lg:mr-auto border-t lg:border-t-0 border-black py-8 text-sm lg:text-2xl contact-form">
                <h2 className="font-semibold text-lg lg:text-3xl">
                    {`Tell us about yourself. You'll love this bit.`}
                </h2>

                <div className="pt-6 flex flex-col lg:flex-row">
                    <div className="flex items-center">
                        <label htmlFor="name" className="sr-only">First and last name</label> <span>Tell us your</span>
                        <input type="text" name="name" id="name" className="ml-2 flex-grow" placeholder="name" required />
                        <span className="ml-2 lg:hidden" >,</span>
                    </div>
                    <div className="flex items-center pt-3 lg:pt-0">
                        <label htmlFor="email" className="sr-only">Email</label><span className="ml-2 hidden lg:inline-block" >,</span><input type="email" name="email" id="email" className="lg:ml-4 flex-grow w-full lg:w-auto" placeholder="email" required /> <span className="ml-2 lg:hidden" >&</span>
                        <span className="ml-4 opacity-0 pointer-events-none hidden lg:inline-block">?</span>
                    </div>

                </div>
                <div className="pt-3 lg:pt-6 flex flex-col lg:flex-row">
                    <div className="flex items-center">
                        <label htmlFor="occupation" className="sr-only">Occupation</label><span className="lg:mr-2 hidden lg:inline-block">&</span><input type="text" name="occupation" id="occupation" className="lg:ml-2 flex-grow" placeholder="occupation" required /><span className="ml-2">.</span>
                    </div>
                    <div className="flex justify-between items-center pt-3 lg:pt-0">
                        <label htmlFor="email" className="sr-only">Is your brand new?</label><span className="lg:ml-2">Is your brand new</span>
                        <label htmlFor="newBrand" className="sr-only">New Brand?</label>
                        <label className="check-container">
                            <input type="radio" id="newBrand" name="brand_status" required />
                            <span className="checkmark"></span>
                        </label>
                        <span>or existing</span>
                        <label htmlFor="existingBrand" className="sr-only">Existing Brand?</label>
                        <label className="check-container">
                            <input type="radio" id="existingBrand" name="brand_status" required />
                            <span className="checkmark"></span>
                        </label>


                        <span>?</span>
                    </div>
                </div>
                <div className="pt-4 flex flex-col lg:flex-row">
                    <div className="flex items-center">
                    <label htmlFor="website" className="sr-only">Website URL</label> <span>Do you have a</span><input type="text" name="website" id="website" className="ml-2 flex-grow" placeholder="website" required />
                    </div>
                    <div className="flex items-center pt-3 lg:pt-0">
                    <span className="lg:ml-2">What do you need most</span>
                    <button type="button" onClick={() => setDropdown(!dropdown)} className={`dropdown-button ${dropdown ? `active` : ``}`}>
                        <DownArrow />
                    </button>
                    <span className="ml-4">?</span>
                    </div>

                </div>

                <div className="pt-3 lg:pt-6 flex items-center">
                    <label htmlFor="additional" className="sr-only">Additional Info</label> <span>Anything</span><textarea type="text" name="additional" id="additional" className="ml-2 flex-grow" placeholder="else" rows={1} />

                    <span className="ml-4">?</span>

                </div>
                <div className="flex lg:justify-end pt-6 items-center">
                    <button type="submit" className="text-lg ml-auto flex space-x-4">
                        <SubmitIcon />    <span>Submit</span>
                    </button>
                </div>

            </form>
    */}

      {/* Mobile Form */}
    </>
  );
};

export default ContactForm;
